export default "__VITE_ASSET__7b57554a__"